import styled from 'styled-components';

// https://github.com/w3c/csswg-drafts/issues/2732
// https://benfrain.com/how-to-get-the-value-of-phone-notches-environment-variables-env-in-javascript-from-css
export const StyledNarrativeIntersectionObserver = styled('div')`
  --safeAreaInsetTop: ${({ theme }) => theme.safeAreaInsetTop};
`;
